import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import {
  saveAnnotationRequest,
  saveAnnotationSuccess,
  saveAnnotationFailure,
} from '../reducers/annotations';
import { API_LINK } from '../../constants';
import { getUserProgramsFullRequest } from '../reducers/userProgramsFull';

const API = `${API_LINK}api/user/`;

function* saveAnnotationAxios() {
  const state = yield select(fullState => fullState);
  const user_id = state.loginReducer.user.userId;
  const {
    token,
  } = state.loginReducer;
  const current_page = 30;
  const {
    selectedContentId: component_id,
  } = state.userProgramsFullReducer;

  const {
    learnerAnnotations: pdf_json,
  } = state.annotationsReducer;
  /*const name = !state.form.saveEdit.values
    ? state.savedVersionsReducer.learnerVersions.find(
      version => version.versionId === state.userProgramsFullReducer.selectedUserVersion,
    ).name
    : state.form.saveEdit.values.Version;*/
    

   
  const response = yield call(() =>
    axios({
      method: 'post',
      url: `${API}${user_id}/storeAnnotation`,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${token}`,
      },
      credentials: 'same-origin',
      data: {
        user_id,
        component_id,
        pdf_json,
        current_page,
      },
    }),
  );
  
  return response;
}

function* workerSaveAnnotationSaga() {
  try {
    
    const response = yield call(saveAnnotationAxios);

    const responseFromSaveAnnotation = response.data;
   console.log('APIANNOT', response)
    if (response.status === 200) {
      yield put(saveAnnotationSuccess(responseFromSaveAnnotation));
      yield put(getUserProgramsFullRequest(responseFromSaveAnnotation));
    }
    if (response.status === 561) {
      yield put(saveAnnotationFailure(response.message));
    }
    if (response.status === 562) {
      yield put(saveAnnotationFailure(response.message));
    }
  } catch (error) {
    console.log('APIANNOT', error)
    yield put(saveAnnotationFailure(error));
  }
}

export function* watcherSaveAnnotationSaga() {
  yield takeLatest(saveAnnotationRequest().type, workerSaveAnnotationSaga);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/post_saveannotations.js